module.exports = __webpack_public_path__ + "static/media/curso-ladder-treinamentos-landing-page-estatico.b35414c4.jpg";